module.exports = (function($) {
    /**
     * CommunityMap constructor
     * 
     * @param {Element}                         mapElement  
     */
    const CommunityMap = function(mapElement) {
        this.initialCenter = new google.maps.LatLng(site_data.MAP_CENTER_LAT,site_data.MAP_CENTER_LNG);
        this.initialZoom = 12;
        this.maxZoom = 18;
        this.mapElement = mapElement;
        this.map = null;
        this.communities = [];
        this.communityMarkers = [];
        this.mapContainClass = 'section-map__map';
        this.mapListContain = document.querySelector('ul.map-list');
        this.mapCenterLat = site_data.MAP_CENTER_LAT;
        this.mapCenterLng = site_data.MAP_CENTER_LNG;
        this.icons = {
            // Default marker off
            pinOff: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/map-pin-off.svg',
                new google.maps.Size(39, 60), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(19, 60), //anchor
                new google.maps.Size(39, 60) //scaled size
            ),
            // Default marker on
            pinOn: new google.maps.MarkerImage(
                site_data.THEME_URL + '/img/map-pins/map-pin-on.svg',
                new google.maps.Size(39, 60), //size
                new google.maps.Point(0, 0), //origin
                new google.maps.Point(19, 60), //anchor
                new google.maps.Size(39, 60) //scaled size
            ),
        };
    };

    /**
     * Initializes the Google map on the page, adds initial markers,
     * and sets up event handlers for various user interactions to
     * update the list of communities displayed.
     * 
     * @param {boolean} controls If map controls should be displayed
     */
    CommunityMap.prototype.initMap = function(controls){
        const self = this;
        // Map arguments
        const args = {
            zoom:              this.initialZoom,
            maxZoom:           this.maxZoom,
            center:            this.initialCenter,
            mapTypeId:         google.maps.MapTypeId.ROADMAP,
            mapTypeControl:    false,
            rotateControl:     false,
            fullscreenControl: false,
            streetViewControl: false,
            disableDefaultUI:  controls === false ? true : false,
            styles:            this.mapStyles
        };

        // Create map and store it for future reference
        self.map = new google.maps.Map(this.mapElement, args);

        // Get initial markers
        self.fetchCommunities(true);

        // When user pans map, change map center and fetch communities
        self.map.addListener('idle', () => {
            const mapCenter = self.map.getCenter();
            if (mapCenter.lat() !== self.mapCenterLat || mapCenter.lng() !== self.mapCenterLng) {
                self.setMapCenterCoords(mapCenter.lat(), mapCenter.lng());
            }
        });

    };

    /**
     * Fetches updated list of communities, refreshes markers and
     * community list.
     * 
     * @param {boolean} initialLoad If this is the initial map load, when the
     *                              bounds should extend to contain all markers
     */
    CommunityMap.prototype.fetchCommunities = function(initialLoad = false) {
        const self = this;

        // Parse map filters and fetch community data
        const params = new URLSearchParams({
            action: 'get_community_map_data',
            map_center_lat: this.mapCenterLat,
            map_center_lng: this.mapCenterLng,
        });
        
        fetch(`${site_data.WP_AJAX}?${params}`)
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    throw new Error(response.errors.join(', '));
                }

                self.communities = response.communities;

                // Replace communities list
                const newMapListContent = self.communities.reduce(
                    (html, community) => {
                        html += community.markup ?? '';
                        return html
                    },
                    ''
                );
                self.mapListContain.innerHTML = newMapListContent;
                // Re-init markers
                self.removeMarkers();
                self.generateMarkers(initialLoad);
            })
            .catch(error => console.log('Unable to fetch updated communities', error));
    };

    /**
     * Removes all markers currently displayed on the map.
     */
    CommunityMap.prototype.removeMarkers = function () {
        this.communityMarkers.forEach(marker => {
            marker.setMap(null);
        });
        this.communityMarkers = [];
    };

    /**
     * Adds markers to the map based on markup in the community list.
     * Optionally extends the bounds of the map to fit all markers.
     * 
     * @param {boolean} initialLoad If this is the initial map load, when the
     *                              bounds should extend to contain all markers
     */
    CommunityMap.prototype.generateMarkers = function (initialLoad = false) {
        const self = this;
        const $markers = $('.map-marker');
        const bounds = new google.maps.LatLngBounds();

        //loop through the markers to set them
        $markers.each(function(index, element){

            const $loc = $(this);
            const locId = $(this).data('id');
            const lat = $(this).data('lat');
            const lng = $(this).data('lng');
            const icon = 'map-pin-off';

            // Marker coordinates
            const latlng = new google.maps.LatLng(lat, lng);
            
            // create marker
            const marker = new google.maps.Marker({
                position: latlng,
                map: self.map,
                optimized: false,
                icon: {
                    url: site_data.THEME_URL + `/img/map-pins/${icon}.svg`,
                    size: new google.maps.Size(39, 60),
                    scaledSize: new google.maps.Size(39, 60),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(19, 60),
                },
                animation: google.maps.Animation.DROP
            });

            if (initialLoad) {
                self.map.setCenter(marker.position);

                // extend maps bounds to include markers
                bounds.extend(marker.position);
                self.map.fitBounds(bounds);
            }
            // if (initialLoad) {
            //     self.map.setCenter({ lat: self.mapCenterLat, lng: self.mapCenterLng })

            //     bounds.extend(marker.position);
            //     self.map.fitBounds(bounds);
            // }

            //add marker to markers array
            self.communityMarkers.push(marker);

            // MARKER CLICK
            marker.addListener('click', function() {
                
                //if marker not already set to active
                if( !$(`.map-marker[data-id='${locId}']`).find('.map-marker__details').is(":visible") ){

                    //toggle correct map marker
                    setMarkerIcon(self.communityMarkers, marker);
                    
                    //close all list items
                    $('.map-marker').each(function(){
                        $(this).removeClass('map-marker--on');
                        $(this).find('.map-marker__details').slideUp();
                    });
                    //expand list item
                    $(`.map-marker[data-id='${locId}']`)
                        .find('.map-marker__details')
                        .slideDown(
                            400,
                            (communityDetails) => {
                                //mobile - hide map, open list
                                $('.section-map__map').removeClass('open');
                                $('.section-map__list').addClass('open');

                                //scroll to the selected list item
                                const $scrollList = $('.section-map__list > ul.map-list');
                                const listItem = $(`.map-marker[data-id='${locId}']`);

                                $scrollList.animate({
                                    scrollTop: $scrollList.scrollTop() - $scrollList.offset().top + listItem.offset().top
                                },500);
                            }
                        );
                        $(`.map-marker[data-id='${locId}']`).addClass('map-marker--on');
                }

            });

        }); //endfor each marker

        //CLICK LIST ITEM TITLE - EXPAND DETAILS AND ACTIVE MARKER
        $('.js-toggle-loc').on({
            click: function(e){
                const listingId = $(this).closest('.map-marker').data('id');
                const index = $(this).closest('.map-marker').index();

                if( !$(this).closest('.map-marker').find('.map-marker__details').is(":visible") ){
                    $('.map-marker').each(function(){
                        $(this).removeClass('map-marker--on');
                        let $details =  $(this).find('.map-marker__details');
                        $details.slideUp();
                        $details.attr("aria-expanded", "false");
                    });
                    let $details =  $(this).closest('.map-marker').find('.map-marker__details');
                    $details.slideDown();
                    $details.attr("aria-expanded", "true");
                    $(this).closest('.map-marker').addClass('map-marker--on');

                    //toggle correct map marker
                    setMarkerIcon(self.communityMarkers, self.communityMarkers[index]);
                }

            }
        });

        // set marker icon 
        //Params: array of all marker objects and the marker object to set as "ON"
        const setMarkerIcon = (communityMarkers, setMarker) => {

            //loop through all markers and turn them off
            for (let j = 0; j < communityMarkers.length; j++) {
                //if the markers icon is the default set it to defaul off
                if( communityMarkers[j].icon.url == site_data.THEME_URL + '/img/map-pins/map-pin-on.svg' ){
                    communityMarkers[j].setIcon(self.icons.pinOff);
                }
            }

            setMarker.setIcon(self.icons.pinOn);
        }
    };

    /**
     * Sets the map center lat/lng.
     * 
     * @param {number} lat 
     * @param {number} lng 
     */
    CommunityMap.prototype.setMapCenterCoords = function (lat, lng) {
        this.mapCenterLat = lat;
        this.mapCenterLng = lng;
    };

    // Return our CommunityMap function so we can use it outside the current scope
    return CommunityMap;

})(jQuery);
